<template>
  <ODialog ref="dialog">
    <v-card v-if="screen != null">
      <ODialogBar title="Editar Screen" @close="dismiss()" />

      <v-card-text class="pa-6">
        <div class="h-row-top">
          <v-switch label="One-Liner?" v-model="screen.isOneLiner" />
          <v-spacer />
          <div class="v-row flex-grow-1">
            <v-text-field
              label="Texto linha 1"
              v-model="screen.line0"
              counter="16"
              class="monospace-input"
            />

            <v-text-field
              label="Texto linha 2"
              :disabled="screen.isOneLiner"
              v-model="screen.line1"
              counter="16"
              class="monospace-input"
            />
          </div>
        </div>

        <div class="grid-4 gap4">
          <v-switch label="Dinâmica?" v-model="screen.isDynamic" />

          <v-select
            label="Variável XX"
            v-model="screen.var0"
            :disabled="!screen.isDynamic"
            :items="screenVarOpts"
          />
          <v-select
            label="Variável YY"
            v-model="screen.var1"
            :disabled="!screen.isDynamic"
            :items="screenVarOpts"
          />
          <v-select
            label="Variável ZZ"
            v-model="screen.var2"
            :disabled="!screen.isDynamic"
            :items="screenVarOpts"
          />
        </div>

        <div class="grid-2 gap4">
          <v-select
            label="Backlight"
            v-model="screen.backlight"
            :items="backlightOpts"
          />
          <v-select label="Função" v-model="screen.func" :items="funcOpts" />
        </div>
      </v-card-text>

      <ODialogButtons class="pa-6" @cancel="dismiss" @apply="apply" />
    </v-card>
  </ODialog>
</template>

<script>
import { backlightOpts, funcOpts, screenVarOpts } from './screen-opts'

export default {
  components: {},
  data() {
    return this.reset()
  },
  methods: {
    reset() {
      return {
        screen: null,
        backlightOpts,
        funcOpts,
        screenVarOpts
      }
    },

    dismiss() {
      return this.$refs.dialog.$dismiss()
    },

    open(screen) {
      Object.assign(this, this.reset())
      this.screen = JSON.parse(JSON.stringify(screen))
      return this.$refs.dialog.$open()
    },

    apply() {
      this.$refs.dialog.$apply(this.screen)
    }
  }
}
</script>

<style lang="sass">
@for $s from 2 through 12
  .grid-#{$s}
    display: grid
    grid-template-columns: repeat($s, 1fr)

.gap4
  gap: 16px
</style>
